<template>
  <section id="about" class="py-5">
    <b-container data-aos="fade-up"
     data-aos-duration="2400">
      <h2 class="text-center">about</h2>
      <p class="text-center mb-5">
        Magnam dolores commodi suscipit. Necessitatibus eius consequatur ex aliquid fuga eum quidem.
        Sit sint consectetur velit. Quisquam quos quisquam cupiditate.
        Et nemo qui impedit suscipit alias ea. Quia fugiat sit in iste officiis commodi quidem hic quas.
      </p>
      <b-row>
        <b-col md="4" xs="12">
          <img
            src="https://bootstrapmade.com/demo/templates/MyResume/assets/img/profile-img.jpg"
            alt
          />
        </b-col>
        <b-col md="8" xs="12">
          <h3 class="float-left" align="left">UI/UX Designer &amp; Web Developer.</h3>
          <p
            align="left"
          >Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
          <ul class="m-0 p-0">
            <b-row class="" >
              <b-col md="6" sm="12">
                <li class="mb-4">
                  <b-icon-chevron-compact-right></b-icon-chevron-compact-right>
                  <strong>Birth Day: </strong><span>1 May 1995</span>
                </li>
                <li class="mb-4">
                  <b-icon-chevron-compact-right></b-icon-chevron-compact-right>
                  <strong>Website: </strong><span>www.example.com</span>
                </li>
                <li class="mb-4">
                  <b-icon-chevron-compact-right></b-icon-chevron-compact-right>
                  <strong>Phone: </strong><span>+123 456 7890</span>
                </li>
                <li class="mb-4">
                  <b-icon-chevron-compact-right></b-icon-chevron-compact-right>
                  <strong>City: </strong><span>New York, USA</span>
                </li>
              </b-col>
              <b-col md="6" sm="12">
                <li class="mb-4">
                  <b-icon-chevron-compact-right></b-icon-chevron-compact-right>
                  <strong>Age: </strong><span>20</span>
                </li>
                <li class="mb-4">
                  <b-icon-chevron-compact-right></b-icon-chevron-compact-right>
                  <strong>Degree: </strong><span>Newbie</span>
                </li>
                <li class="mb-4">
                  <b-icon-chevron-compact-right></b-icon-chevron-compact-right>
                  <strong>PhEmailone: </strong><span>10 December 2001</span>
                </li>
                <li class="mb-4">
                  <b-icon-chevron-compact-right></b-icon-chevron-compact-right>
                  <strong>Freelance: </strong><span>Available</span>
                </li>
              </b-col>
            </b-row>
          </ul>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style scoped>
img {
  max-width: 100%;
  object-fit: cover;
}
#about {
    /* height: 600px; */
}
</style>